const ALLOWED_LEGALIZACAO_EMAILS = new Set([
  'anderson@ativagestao.com.br',
  'roberto@ativagestao.com.br',
]);

export function canAccessLegalizacao(email: string | undefined | null): boolean {
  if (!email) return false;

  const normalizedEmail = email.trim().toLowerCase();
  const atIndex = normalizedEmail.lastIndexOf('@');
  if (atIndex < 1) return false;

  return normalizedEmail.slice(atIndex + 1) === 'crasdata.com.br'
    || ALLOWED_LEGALIZACAO_EMAILS.has(normalizedEmail);
}